import { Component, Input, OnInit } from '@angular/core';
import {Magazzino} from "../_Models/magazzino";

@Component({
  selector: 'app-movimentazione',
  templateUrl: './movimentazione.component.html',
  styleUrls: ['./movimentazione.component.css']
})
export class MovimentazioneComponent implements OnInit {
  @Input() Magazzino: Magazzino;
  constructor() { }

  ngOnInit(): void {
  }

  Save(close?: boolean) {

  }
  Close(){

  }
}
